<!-- src/views/Home.vue -->
<template>
  <div class="home">
    <!-- <van-loading size="24px" vertical>加载中...</van-loading> -->
    <!-- 首页搜索栏 -->
    <div class="search-bar">
      <div class="search-input" @click="homeSearch">
        <img class="search-icon" src="@/assets/images/search_icon.png" alt="" />
        <input
          readonly
          class="custom-input"
          type="text"
          placeholder="搜索游戏名称"
        />
      </div>
      <!-- 下载列表分享按钮 -->
      <div class="bar-operate">
        <img
          @click="gridOperate({ key: 'myCollect' })"
          src="@/assets/images/home-collect.png"
          alt=""
        />
        <img
          @click="gridOperate({ key: 'inviteFriends' })"
          src="@/assets/images/share.png"
          alt=""
        />
      </div>
    </div>
    <!-- 游戏卡片轮播区 -->
    <div class="banner">
      <swiper
        v-if="bannerList.length"
        :options="swiperOption"
        ref="mySwiper"
        class="swiper"
      >
        <swiper-slide
          v-for="item in bannerList"
          :key="item.id"
          class="swiper_item"
        >
          <div
            @click="jumpDetail({ game_id: item.gotoUrl })"
            class="img"
            :style="{
              background: `url(${item.bannerUrl})`,
              'background-size': '100% 100%',
            }"
          >
            <div class="banner-info">
              <div class="banner-info-title">
                <h1>{{ item.gameName }}</h1>
                <span>{{ item.discount }}</span>
              </div>
              <div class="banner-game-tag">
                <span v-for="(info, ind) in item.type" :key="ind">{{
                  info
                }}</span>
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <!-- 选项分类区 -->
    <div class="category-grid">
      <div
        class="grid-item"
        v-for="item in gridList"
        :key="item.key"
        @click="gridOperate(item)"
      >
        <img class="grid-icon" :src="item.icon" alt="" />
        <span class="grid-label">{{ item.label }}</span>
      </div>
    </div>

    <!-- 特价推荐专区 -->
    <div class="special-recommend">
      <div
        class="special-recommend-game"
        @click="gridOperate({ key: 'oneOff' })"
      >
        <div class="block-title">
          <img class="icon-lighting" src="@/assets/images/icon1.png" alt="" />
          <span>无限0.1折</span>
        </div>
        <!-- 推荐专区左侧0.1折 -->
        <div class="game-list">
          <div class="game-item" v-for="(item, index) in top2List" :key="index">
            <img class="logo" :src="item.logo_url" alt="" />
            <span class="game-top2-list-item-title">{{ item.game_name }}</span>
            <!-- 游戏标签 -->
            <div class="block-tag">
              <span>首续{{ item.discount }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧蒙层推荐区 -->
      <div class="mask">
        <div
          class="special-offer"
          @click="gridOperate({ key: 'specialOffer' })"
        >
          <span>特价专区</span>
          <span>超高性价比</span>
          <img class="icon-mask" src="@/assets/images/icon-mask2.png" alt="" />
        </div>
        <div
          class="account-trading"
          @click="gridOperate({ key: 'accountTrade' })"
        >
          <span>账号交易</span>
          <span>闲置账号回血</span>
          <img class="icon-mask" src="@/assets/images/icon-mask3.png" alt="" />
        </div>
        <!-- <div
          v-else
          class="account-trading"
          @click="gridOperate({ key: 'selectedMaster' })"
        >
          <span>精选大作</span>
          <span>玩精品游戏</span>
          <img class="icon-mask" src="@/assets/images/icon-mask1.png" alt="" />
        </div> -->
      </div>
    </div>

    <!-- 首页游戏列表 -->
    <div class="home-game-list" v-for="item in indexDemoList" :key="item.sort">
      <div class="game-list-title">
        <div class="headline">
          <h1>{{ item.title }}</h1>
          <div class="decorative-line">
            <span></span>
            <span></span>
          </div>
        </div>
        <span class="headline-desc">{{ item.subtitle }}</span>
      </div>

      <div class="game-list-container">
        <div
          class="game-item"
          v-for="(info, indexb) in item.gameList"
          :key="indexb"
        >
          <div v-if="indexb != 1" class="game-box">
            <div class="game-item-content" @click="jumpDetail(info)">
              <img class="game-logo" :src="info.logo_url" alt="" />
              <div class="game-info">
                <div class="game-info-title">
                  <h1>{{ info.game_name }}</h1>
                  <span>{{ info.discount }}</span>
                </div>
                <div class="game-info-desc">
                  <div class="game-info-gift">
                    <span v-if="info.wealf">福利</span>
                    <span v-if="!info.wealf && info.havaGift == 1">礼包</span>
                    <span v-if="info.isBTgame">变态特权</span>
                    <span v-if="info.waterMark == 1">专属折扣</span>
                    <span
                      v-if="
                        info.havaGift == 0 &&
                        !info.isBTgame &&
                        !info.wealf &&
                        info.waterMark == 0
                      "
                      >{{ info.title }}</span
                    >
                  </div>
                  <div class="star" v-if="info.starInfo">
                    <img
                      :key="star"
                      v-for="star in info.starInfo.allStar"
                      src="@/assets/images/star_all.png"
                      alt=""
                    />
                    <img
                      :key="star + 999"
                      v-for="star in info.starInfo.halfStar"
                      src="@/assets/images/star_half.png"
                      alt=""
                    />
                  </div>
                </div>
                <div class="game-tag">
                  <span v-for="tag in info.formatGameType" :key="tag">{{
                    tag
                  }}</span>
                  <span class="other-tag">{{ info.openServerDate }}</span>
                </div>
              </div>
            </div>
            <operateBtns :gameInfo="info" @doOperate="doOperate" />
            <!-- <div class="game-item-operate">
              <span @click="doOperate(info, 'recharge')">充值</span>
              <span @click="doOperate(info, 'download')">下载</span>
            </div> -->
          </div>
          <div
            class="game-image-show"
            v-if="indexb == 1 && info.indexDemoValueType == 'PIC_URL'"
            :style="{ height: info.picType == 'SMALL' ? '85px' : '150px' }"
            @click="jumpDetail(info)"
          >
            <img :src="info.indexDemoValueContent" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div @click="gridOperate({ key: 'allGame' })" class="more-game-btn" v-show="indexDemoList.length">点击查看更多游戏</div>
    <div class="btn-shadow" v-show="indexDemoList.length"></div>
    <gamePlatPopup
      v-if="gamePlatPopupVisible"
      v-model="gamePlatPopupVisible"
      :btnType="btnType"
      :gameInfo="gameInfo"
    ></gamePlatPopup>

    <noticeDialog
      v-if="noticeDialogVisible"
      v-model="noticeDialogVisible"
      :noticeInfo="paramInfo"
    />
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { requestMethods } from "@m/api";
import { mapGetters, mapActions } from "vuex";
import mixins from "@/mixin";
import gamePlatPopup from "@/components/GamePlatPopup.vue";
import noticeDialog from "@/components/NoticeDialog.vue";
import operateBtns from "@/components/OperateBtns.vue"
export default {
  mixins: [mixins],
  name: "homePage",

  components: {
    swiper,
    swiperSlide,
    gamePlatPopup,
    noticeDialog,
    operateBtns
  },

  data() {
    return {
      swiperOption: {
        effect: "coverflow",
        centeredSlides: true,
        spaceBetween: "11%",
        slidesPerView: "auto",
        loop: true,
        autoplay: true, // 是否自动播放
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
      },
      bannerList: [],
      indexDemoList: [],
      gridList: [
        {
          icon: require("@/assets/images/grid1.png"),
          label: "今日首发",
          key: "firstEpisode",
        },
        {
          icon: require("@/assets/images/grid2.png"),
          label: "今日开服",
          key: "openServer",
        },
        {
          icon: require("@/assets/images/grid6.png"),
          label: "排行榜",
          key: "rank",
        },
        {
          icon: require("@/assets/images/grid3.png"),
          label: "签到&月卡",
          key: "signCard",
        },
        {
          icon: require("@/assets/images/grid7.png"),
          label: "快捷充值",
          key: "recharge",
        },
        {
          icon: require("@/assets/images/grid4.png"),
          label: "游戏圈",
          key: "gameCircle",
        },
        {
          icon: require("@/assets/images/grid5.png"),
          label: "邀请送礼",
          key: "inviteFriends",
        },
        {
          icon: require("@/assets/images/grid8.png"),
          label: "精选大作",
          key: "selectedMaster",
        },
      ],
      recommendGameList: [
        {
          logo: require("@/assets/images/logo1.png"),
          gameName: "龙刃",
          desc: "首续0.1折",
        },
        {
          logo: require("@/assets/images/logo2.png"),
          gameName: "异度之刃OL",
          desc: "首续0.1折",
        },
      ],
      top2List: [],
      defaultSwiper: null,
      gamePlatPopupVisible: false,
      btnType: "00",
      gameInfo: {},
      noticeDialogVisible: false,
      paramInfo: {},
    };
  },

  computed: {
    ...mapGetters([
      "deviceId",
      "userInfo",
      "uuid",
      "noticeInfo",
      "homeGames",
      "isLogin",
    ]),
    //定义这个swiper对象
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  async created() {
    if (!this.deviceId) {
      await this.updateDeviceId();
    }
  },
  async mounted() {
    this.gridInit();
    await this.requestInit();
    this.getNoticeInfo();
    this.qryConfigData()
    // this.getIp();
  },

  methods: {
    ...mapActions(["updateNoticeInfo", "updateHomeGames", "updateDeviceId", "updateConfigInfo"]),
    /**
     * request init promise all
     */
    async requestInit() {
      await this.gameTop2ListQr();
      await this.appIndexInfo4Banner();
      await this.appIndexInfo4GameList();
    },
    /**
     * 宫格权限判断
     */
    gridInit() {
      if (this.uuid && this.userInfo.vipLevel >= 3) {
        this.gridList.push({
          icon: require("@/assets/images/grid9.png"),
          label: "猜你喜欢",
          key: "youlike",
        });
      }
    },

    /**
     * banner获取
     */

    async appIndexInfo4Banner() {
      console.log(this.deviceId, "banner");
      try {
        const { data } = await requestMethods(
          "/modules/web/game/appIndexInfo4Banner.htm",
          "post",
          {
            deviceNo: this.deviceId,
            uuid: this.uuid,
            appType: "WM",
          }
        );
        const { bannerList } = data;
        this.bannerList = bannerList || [];
      } catch (error) {
        // this.$toast(error.message);
        this.dialogText =
        "检测到您的账号在别的设备上登录，是否重新登录？";
        this.$dialog.confirm({
          title: "温馨提示",
          width: "260px",
          message: this.dialogText,
          confirmButtonColor: "#FF7A3E",
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          messageAlign: "left",
        }).then(() => {
          this.$router.push('/login')
        })
      }
    },
    /**
     * 首页banner和游戏列表数据获取
     */
    async appIndexInfo4GameList() {
      console.log(this.deviceId, "ganmelist");
      if (this.homeGames && this.homeGames.length > 0) {
        this.indexDemoList = this.homeGames;

        try {
          const { data } = await requestMethods(
            "/modules/web/game/appIndexInfo4GameList.htm",
            "post",
            {
              deviceNo: this.deviceId,
              uuid: this.uuid,
              appType: "WM",
            }
          );
          const { indexDemoList } = data;
          let list = this.gameInit(indexDemoList) || [];
          this.indexDemoList = list
          this.updateHomeGames(list);
        } catch (error) {
          // this.$toast(error.message);
          this.dialogText =
          "检测到您的账号在别的设备上登录，是否重新登录？";
          this.$dialog.confirm({
            title: "温馨提示",
            width: "260px",
            message: this.dialogText,
            confirmButtonColor: "#FF7A3E",
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            messageAlign: "left",
          }).then(() => {
            this.$router.push('/login')
          })
        }
      } else {
        try {
          const { data } = await requestMethods(
            "/modules/web/game/appIndexInfo4GameList.htm",
            "post",
            {
              deviceNo: this.deviceId,
              uuid: this.uuid,
              appType: "WM",
            }
          );
          const { indexDemoList } = data;
          this.indexDemoList = this.gameInit(indexDemoList) || [];
          this.updateHomeGames(this.indexDemoList);
        } catch (error) {
          this.$toast(error.message);
        }
      }
    },

    /**
     * 首页无限0.1折2个游戏列表
     */
    async gameTop2ListQr() {
      try {
        const { data } = await requestMethods(
          "/modules/web/game/getGameList.htm",
          "post",
          {
            searchParams: JSON.stringify({
              gameType: "newGame",
              location: "GAME_LIST",
            }),
            currentPage: 1,
            pageSize: 2,
          }
        );
        this.top2List = data || [];
      } catch (err) {
      this.$toast(err.message);}
    },

    /**
     * 获取首页弹窗提示
     */
    async getNoticeInfo() {
      try {
        const { data } = await requestMethods(
          "/modules/FrameAction/getFrame.htm",
          "post"
        );
        if (this.noticeInfo && this.noticeInfo.id) {
        } else {
          this.paramInfo = data;
          this.noticeDialogVisible = true;
          this.updateNoticeInfo(data);
        }
      } catch (err) {
        // 通过 err.message 获取到错误信息
        this.$toast(err.message);
      }
    },

    /**
     * 查询配置信息
     */
    async qryConfigData() {
      try {
        const { data } = await requestMethods(
          "/modules/appparam/appParam/getAppParamList.htm",
          "post",
          {
            currentPage: 1,
            pageSize: 50,
            appType: "XL",
            'user.os': 'ANDROID',
            'user.os.version': '30',

          }
        );
        console.log(data, 'data')
        this.updateConfigInfo(data);
      } catch (err) {
      this.$toast(err.message);}
    },

    /**
     * 跳转到首页搜索
     */
    homeSearch() {
      this.$router.push({ path: "/homeSearch" });
    },

    /**
     * 跳转游戏详情
     */
    jumpDetail(info) {
      this.$router.push({ path: "/detail", query: { gameId: info.game_id } });
    },

    /**
     * 宫格跳转
     */
    gridOperate(item) {
      switch (item.key) {
        case "firstEpisode":
          this.$router.push({
            path: "/firstEpisode",
            query: { currentKey: 1 },
          });
          break;
        case "openServer":
          this.$router.push({ path: "/openServer", query: { currentKey: 1 } });
          break;
        case "rank":
          this.$router.push({ path: "/rank", query: { currentKey: 1 } });
          break;
        case "specialOffer":
          this.$router.push({ path: "/specialOffer" });
          break;
        case "oneOff":
          this.$router.push({ path: "/oneOff" });
          break;
        case "gameCircle":
          this.$router.push({ path: "/gameCircle" });
          break;
        case "selectedMaster":
          this.$router.push({ path: "/selectedMaster" });
          break;
        case "inviteFriends":
          this.$router.push({ path: "/inviteFriends" });
          break;
        case "recharge":
          this.$router.push({ path: "/recharge", query: { page: "quick" } });
          break;
        case "signCard":
          this.$router.push({ path: "/signCard" });
          break;
        case "youlike":
          this.$router.push({ path: "/youLike" });
          break;
        case "accountTrade":
          this.$router.push({ path: "/accountTrade" });
          break;
        case "myCollect":
          this.$router.push({ path: "/myCollect" });
          break;
        case "allGame":
          this.$router.push({ path: "/allGame" });
          break;
      }
    },

    doOperate(scope, chennel) {
      // if (!this.isLogin) {
      //   this.$router.push("/login");
      //   return;
      // }
      this.btnType = chennel == "recharge" ? "00" : "01";
      this.gameInfo = {
        gameName: scope.game_name,
        gameId: scope.game_id,
      };
      this.gamePlatPopupVisible = true;
    },

    /**
     * 上报用户设备标识ip
     */
    async getIp() {
      fetch("http://v4.ip.zxinc.org/getip")
        .then((response) => response.text())
        .then((data) => {
          // console.log(data, 'data---')
          this.sendDeviceNo(data);
        })
        .catch((error) => {
          this.$toast(error);
        });
    },

    async sendDeviceNo(ip) {
      try {
        await requestMethods("/modules/user/user/sendDeviceNo.htm", "post", {
          uuid: this.uuid,
          deviceNo: this.deviceId,
          ip: ip,
        });
      } catch (err) {
        // 通过 err.message 获取到错误信息
        this.$toast(err.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 438px;
}
.banner-info {
  position: absolute;
  left: 32px;
  bottom: 32px;

  .banner-info-title {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    h1 {
      font-weight: 600;
      font-size: 30px;
      color: #ffffff;
      line-height: 42px;
      margin-right: 34px;
    }
    span {
      display: inline-block;
      padding: 0 5px;
      font-weight: 600;
      font-size: 22px;
      color: #ffffff;
      line-height: 30px;
      background: #ff7a3e;
      border-radius: 2px;
    }
  }
  .banner-game-tag {
    span {
      padding: 4px 14px;
      border-radius: 22px;
      border: 1px solid #ffffff;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      line-height: 25px;
      margin-right: 15px;
      background: rgba(255, 255, 255, 0.4);
    }
  }
}

.swiper-container {
  width: 100%;
  height: 100%;
  // overflow: visible !important;
}

.swiper-wrapper .swiper-slide {
  width: 680px;
  height: 100%;
  border-radius: 10px;
}

.swiper-wrapper .swiper-slide .img {
  position: relative;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  border-radius: 10px;
}

.search-bar {
  padding: 24px 35px 24px 35px;
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 9999;
  background: #fff;

  .search-input {
    position: relative;
    width: 490px;

    input {
      width: 490px;
      height: 60px;
      background: #f4f4f4;
      border-radius: 30px;
      border: none;
      padding: 0 60px;
    }

    .custom-input::placeholder {
      color: #858585; /* 颜色 */
      font-size: 24px; /* 字体大小 */
      font-weight: 500; /* 粗体 */
    }

    .search-icon {
      width: 30px;
      height: 30px;
      position: absolute;
      left: 22px;
      top: 14px;
    }
  }

  .bar-operate {
    display: flex;
    align-items: center;

    img {
      width: 48px;
      height: 48px;

      &:last-child {
        margin-left: 50px;
      }
    }
  }
}

.category-grid {
  padding: 0 35px;
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
  align-items: center;

  .grid-item {
    /* 根据需要设置宽度和边距 */
    width: 88px;
    margin: 30px 20px;
    display: block;
    text-align: center;

    .grid-icon {
      width: 80px;
      margin-bottom: 10px;
    }

    .grid-label {
      display: block;
      width: 88px;
      font-weight: 400;
      font-size: 22px;
      color: #414141;
    }
  }
}

.special-recommend {
  margin-top: 30px;
  padding-left: 30px;
  display: flex;

  .special-recommend-game {
    width: 450px;
    height: 280px;
    background: url("~@/assets/images/mask1.png");
    background-size: 100% 100%;
    position: relative;
    margin-right: 18px;
  }

  .block-title {
    width: 236px;
    height: 56px;
    position: absolute;
    left: 0px;
    top: -18px;
    background: url("~@/assets/images/bg1.png");
    background-size: 100% 100%;
    display: flex;
    align-items: center;

    .icon-lighting {
      width: 30px;
      height: 30px;
      margin-left: 27px;
      margin-right: 5px;
    }
    span {
      font-weight: 600;
      font-size: 28px;
      color: #ffffff;
      line-height: 40px;
      text-align: justify;
      font-style: normal;
    }
  }

  .game-list {
    padding: 35px 0px 30px 37px;
    .game-item {
      display: flex;
      align-items: center;
      position: relative;
      margin-top: 23px;

      .logo {
        width: 80px;
        height: 80px;
        margin-right: 20px;
      }

      // span {
      //   font-weight: 400;
      //   font-size: 28px;
      //   color: #212121;
      //   line-height: 40px;
      //   text-align: left;
      //   font-style: normal;
      // }

      .block-tag {
        width: 114px;
        height: 45px;
        position: absolute;
        right: -10px;
        top: 19px;
        background: url("~@/assets/images/bg2.png");
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-weight: 600;
          font-size: 16px;
          color: #ffffff;
          line-height: 22px;
          font-style: normal;
        }
      }

      .game-top2-list-item-title {
        font-weight: 400;
        font-size: 28px;
        color: #212121;
        line-height: 40px;
        text-align: left;
        font-style: normal;
        display: block;
        width: 200px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .special-offer,
  .account-trading {
    width: 210px;
    height: 130px;
    padding: 17px 12px;
    position: relative;

    span {
      display: block;
      font-weight: 400;
      font-size: 20px;
      line-height: 28px;
      text-align: justify;
      font-style: normal;

      &:first-child {
        font-weight: 600;
        font-size: 28px;
        margin-bottom: 5px;
      }
    }
  }

  .special-offer {
    background: url("~@/assets/images/mask3.png");
    background-size: 100% 100%;
    margin-bottom: 20px;

    span {
      color: #ffffff;
      text-shadow: 0px 2px 4px rgba(188, 83, 83, 0.5);
    }
  }
  .account-trading {
    background: url("~@/assets/images/mask2.png");
    background-size: 100% 100%;

    span {
      color: rgba(255, 255, 255, 0.8);
      text-shadow: 0px 2px 4px #7e95cd;
    }
  }

  .icon-mask {
    position: absolute;
    width: 65px;
    height: 90px;
    bottom: 0;
    right: -12px;
  }
}

.home-game-list {
  margin-top: 60px;
}

.game-list-title {
  padding-left: 35px;
  h1 {
    font-weight: 600;
    font-size: 40px;
    color: #000000;
    line-height: 40px;
    font-style: normal;
  }
  .headline {
    display: flex;
    align-items: flex-end;

    .decorative-line {
      flex: 1;
      margin-left: 20px;
      span {
        display: flex;

        &:first-child {
          width: 10px;
          height: 10px;
          background: #d8d8d8;
        }
        &:last-child {
          height: 1px;
          background: #e6e6e6;
        }
      }
    }
  }
  .headline-desc {
    display: block;
    font-weight: 400;
    font-size: 22px;
    color: #bbbbbb;
    line-height: 30px;
    margin-top: 12px;
  }
}

.game-list-container {
  padding: 40px 40px 0 40px;

  .game-item {
    .game-box {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 30px;
    }
    &:last-child {
      .game-box {
        margin-bottom: 0;
      }
    }
  }

  .game-item-content {
    display: flex;
    align-items: center;

    .game-logo {
      width: 132px;
      height: 132px;
      margin-right: 20px;
    }
    .game-info {
      .game-info-title {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        h1 {
          max-width: 300px;
          font-weight: 600;
          font-size: 32px;
          color: #000000;
          line-height: 45px;
          margin-right: 6px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        span {
          display: block;
          padding: 5px 5px;
          font-weight: 600;
          font-size: 22px;
          color: #ffffff;
          height: 30px;
          background: #ff7a3e;
          border-radius: 4px;
        }
      }
      .game-info-desc {
        width: 390px;
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .game-info-gift {
          span {
            padding: 4px 12px;
            background: #f8f8f8;
            border-radius: 4px;
            border: 1px solid #f8f8f8;
            font-weight: 500;
            font-size: 18px;
            color: #a2a2a2;
            margin-right: 8px;
          }
        }
        .star {
          display: flex;
          align-items: center;
          img {
            width: 24px;
            margin-right: 8px;
          }
        }
      }
      .game-tag {
        span {
          padding: 2px 6px;
          // background: #f8f8f8;
          border-radius: 22px;
          border: 0px solid #d2d2d2;
          font-weight: 600;
          font-size: 20px;
          color: #a2a2a2;
          // margin-right: 18px;
        }
        .other-tag {
          color: #ffbe70;
        }
      }
    }
  }

  .game-item-operate {
    span {
      display: block;
      width: 105px;
      height: 50px;
      border-radius: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 28px;
      line-height: 50px;
      text-align: center;

      &:first-child {
        color: #ffffff;
        background: #ff7a3e;
        margin-bottom: 23px;
      }
      &:last-child {
        border: 2px solid #ff7a3e;
        color: #ff7a3e;
      }
    }
  }

  .game-image-show {
    width: 100%;
    height: 300px;
    margin-bottom: 30px;
    border-radius: 16px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 16px;
    }
  }
}

.more-game-btn {
  background: url(~@/assets/images/bg_home_all_game_one.png);
  background-size: 100% 100%;
  width: 504px;
  height: 58px;
  text-align: center;
  line-height: 58px;
  color: #ff7a3e;
  font-size: 28px;
  margin: 0 auto;
  margin-top: 24px;
}
.btn-shadow {
  background: url(~@/assets/images/bg_home_all_game_two.png);
  background-size: 100% 100%;
  margin: 0 auto;
  width: 366px;
  height: 32px;
  margin-bottom: 24px;
}

::-webkit-scrollbar {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/home/index.vue